import { observer } from "mobx-react";
import React from "react";
import { ColorScheme } from "../constants/options";
import { ITEM_PERFECT_INLINED } from "../constants/style";
import { Box, CircularProgress, Tooltip } from "@mui/material";

const VmButton = observer(({
  className = "", children, disabled = false, disabledHover = false, rounded = "lg", style = {}, onClick, colorScheme = ColorScheme.INITIAL, variant = "filled", loading = false, small = false, loadingText = "Loading...", ref = null, tooltip = "" }: {
    className?: string,
    children: any,
    rounded?: "none" | "md" | "lg" | "xl";
    disabled?: boolean,
    disabledHover?: boolean,
    style?: any,
    onClick?: (e: any) => any | any,
    colorScheme?: ColorScheme,
    loading?: boolean,
    loadingText?: string,
    small?: boolean,
    variant?: "outlined" | "filled",
    ref?: any,
    tooltip?: string,
  }) => {

  const bgFilledStyle = `${disabled || loading ? 'bg-gray-400 cursor-not-allowed text-white border-gray-400' :
    colorScheme === ColorScheme.DISABLED ? 'bg-gray-400 text-white border-gray-400' :
      colorScheme === ColorScheme.INFO ? 'bg-[#0284c7] text-white border-[#0284c7]' :
        colorScheme === ColorScheme.INITIAL ? 'bg-themeGreen text-white border-themeGreen' :
          colorScheme === ColorScheme.ERROR ? "bg-red-500 text-white border-red-500" :
            colorScheme === ColorScheme.SUCCESS ? "bg-green-500 text-white border-green-500" : "bg-orange-400 text-white border-orange-400"}`;

  const bgOutlinedStyle = `${disabled || loading ? 'bg-transparent cursor-not-allowed text-gray-400 border-gray-400' :
    colorScheme === ColorScheme.DISABLED ? 'bg-gray-400 text-white border-gray-400' :
      colorScheme === ColorScheme.INITIAL ? 'bg-transparent text-themeGreen border-themeGreen' :
        colorScheme === ColorScheme.INFO ? 'bg-transparent text-[#0284c7] border-[#0284c7]' :
          colorScheme === ColorScheme.ERROR ? "bg-transparent text-red-500 border-red-500" :
            colorScheme === ColorScheme.SUCCESS ? "bg-transparent text-green-500 border-green-500" : "bg-transparent text-orange-400 border-orange-400"}`;

  return (
    <Tooltip title={tooltip} placement="top" arrow>
      {loading ?
        <button
          ref={ref}
          type="button"
          disabled={true}
          style={style}
          className={`${bgOutlinedStyle} ${small ? "py-1 px-2" : "py-1 px-3"} border-2 rounded-md hover:border-black hover:bg-transparent hover:text-black transition ease-in-out ${className}`}>
          <Box className={`${small ? "text-xs" : ""} flex justify-center items-center`}>
            <CircularProgress color="inherit" size={"0.7rem"} />
            <p className="ml-2">{loadingText}</p>
          </Box>
        </button>
        : variant === "outlined" ?
          <button
            ref={ref}
            type="button"
            onClick={onClick}
            disabled={disabled}
            style={style}
            className={`${bgOutlinedStyle} ${small ? "py-1 px-2" : "py-1 px-3"} border-2 rounded-md 
            ${!disabledHover && "hover:border-black hover:bg-transparent hover:text-black"} transition ease-in-out ${className}`}>
            <Box className={`${small ? "text-xs" : ""} justify-center`} sx={{ ...ITEM_PERFECT_INLINED, gap: 0.5 }}>{children}</Box>
          </button>
          : <button
            ref={ref}
            type="button"
            onClick={onClick}
            disabled={disabled}
            style={style}
            className={`shadow-lg ${bgFilledStyle} ${small ? "py-1 px-2" : "py-1 px-3"} border-2 rounded-md
            ${!disabledHover && "hover:border-black hover:bg-transparent hover:text-black"} transition ease-in-out ${className}`}>
            <Box className={`${small ? "text-sm" : ""} justify-center`} sx={{ ...ITEM_PERFECT_INLINED, gap: 0.5 }}>{children}</Box>
          </button>}
    </Tooltip>
  );
});
export default VmButton;